import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  pinInputWrapper: {
    display: 'flex',
    justifyContent: 'space-around',
    margin: `0 -${theme.spacing() / 2}px`,
    marginTop: theme.spacing(4),
    position: 'relative'
  },
  hiddenInput: {
    position: 'absolute',
    margin: '0',
    padding: '0',
    backgroundColor: 'transparent',
    border: 'none',
    width: '100%',
    height: '100%',
    zIndex: '1',
    outline: 'none',
    color: 'transparent'
  },
  pinInput: {
    margin: `0 ${theme.spacing() / 2}px`
  },
  pinInputInput: {
    textAlign: 'center',
    padding: '16px 0',
    fontSize: '20px'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/LoginForm/PinInput/styles.js